<template>
  <div>
    <header-vue></header-vue>
    <br><br><br><br>
    <div>
    豚丼食べたい
    <child buttonStyle="red" @childEvent="childEvent1">1</child>
    <child buttonStyle="blue" @childEvent="childEvent2">
      <label>2</label>
    </child>
    <child buttonStyle="green" @childEvent="childEvent3">
      <div>3</div>
    </child>
    <p>count : {{count}}</p>
    <p>{{message}}</p>
    <br>
    <tab-parent></tab-parent>

    <br><br><br>
    <div>
      <p>今でも上手く出来ないRouter</p>
    </div>

    <br><br><br>
      <method-parent></method-parent>
    <br><br><br>

    <footer-vue>  </footer-vue>
    </div>
  </div>
</template>

<script>
import HeaderVue from './Header'
import FooterVue from './Footer'
import Child from './Child.vue'
import TabParent from './tabParent'
import RouterCompParent from './RouterCompParent'
import MethodParent from './test/MethodParent.vue'

export default {
  components: {
    HeaderVue,
    FooterVue,
    Child,
    TabParent,
    RouterCompParent,
    MethodParent
  },
  data () {
    return {
      count: 0,
      message: 'msg test #1 from parent'
    }
  },
  methods: {
    childEvent1: function () {
      console.log('console Event')
      alert('console print out complete')
    },
    childEvent2: function () {
      alert('alert Event?')
    },
    childEvent3: function () {
      this.count++
    }
  }
}
</script>

<style scoped>
* {
  margin: 0 auto;
}
</style>
